import type { Guard } from './index';
import { useAppStore } from '@/store/app.store';
import { useAuthStore } from '@/store/auth.store';

const authentication: Guard = async (to, from, next) => {
  const authStore = useAuthStore();

  const consumed = await authStore.actionLoginFromRDR();
  if (consumed) {
    return next('/');
  }

  if (!authStore.getMemberId()) {
    return next('/sign-in');
  }
  if (!authStore.getSiteId()) {
    return next('/sign-in-site');
  }
  // VSUS-1754: apos login sem reload as settings do site nunca eram buscadas.
  // actionLoad e idempotente: no-op quando ja carregou.
  await useAppStore().actionLoad();
  return next();
};

export default authentication;
